// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/_css-loader@3.3.2@css-loader/dist/runtime/api.js");
exports = module.exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".s-nav-menu-item[data-v-52ef59e9]{padding:0 0 0 20px;color:#fff}.s-nav-menu-item[data-v-52ef59e9]:hover{background:#434a50}.active[data-v-52ef59e9]{color:#ffc879}", ""]);
